import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import ProgressBar from '../ProgressBar';

const defaultMessage = 'Something went wrong. Try again later...';

const ProgressBarPopUp = ({
                         showProgressBarPopUp,
                         hideProgressBarPopUp,
                         message = defaultMessage,
                       }) => {

  return (
    <Modal
      show={showProgressBarPopUp}
      onHide={hideProgressBarPopUp}
      backdrop="static"
    >
      <Modal.Body>
        <div className="d-flex flex-column align-items-center justify-content-around">
          <h2 className="font-weight-bold mb-8 text-center">
            {message}
          </h2>
        </div>
        <ProgressBar/>
      </Modal.Body>
    </Modal>
  )
};

ProgressBarPopUp.propTypes = {
  showProgressBarPopUp: PropTypes.bool,
  hideProgressBarPopUp: PropTypes.func,
  message: PropTypes.string,
};

export default ProgressBarPopUp;
